
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ig-follower-export-tool",
      function () {
        return require("private-next-pages/ig-follower-export-tool.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ig-follower-export-tool"])
      });
    }
  